import React from 'react';
import './EditorialBoard.css';

function EditorialBoard() {
  const editors = [
    {
      name: "Prof. Ram Tawakya Singh",
      position: "Chief Editor",
      qualification: "Ph.D.",
      details: "Former Dean & Head, Deptt. of Chemistry, V.K.S.U. Ara"
    },
    {
      name: "Prof. Ranjit K. Verma",
      position: "Chief Editor",
      qualification: "Ph.D. (Chemistry)",
      details: "Ex-Pro-Vice-Chancellor, Patna University & V.C. (Munger University, Munger, Bihar)"
    },
    {
      name: "Prof. Suresh Prasad Srivastava",
      position: "Chief Editor",
      qualification: "Ph.D.",
      details: "Ex-Head, Department of Zoology, V.K.S.U. Arrah"
    },
    {
      name: "Prof. Rajesh Kumar",
      position: "Chief Editor",
      qualification: "Ph.D.",
      details: "Former-Head, Department of Botany, V.K.S.U. Arrah (Bihar)"
    },
    {
      name: "Prof. Benay K. Sinha",
      position: "Chief Editor",
      qualification: "Ph.D.",
      details: "Department of Physics, Institute of Excellence in Higher Education (Govt. of Madhya Pradesh, Bhopal)"
    }
  ];

  return (
    <section id="editorial-board" className="editorial-section">
      <div className="section-container">
        <h2 className="section-title">Chief Editors</h2>
        <p className="section-subtitle">Our distinguished editorial board members</p>

        <div className="editors-grid">
          {editors.map((editor, index) => (
            <div key={index} className="editor-card">
              <div className="editor-avatar">
                <div className="avatar-circle">
                  {editor.name.split(' ').map(n => n[0]).slice(0, 2).join('')}
                </div>
              </div>
              <div className="editor-info">
                <h3 className="editor-name">{editor.name}</h3>
                <p className="editor-qualification">{editor.qualification}</p>
                <p className="editor-position">{editor.position}</p>
                <p className="editor-details">{editor.details}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default EditorialBoard;
